import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchProducts(params = {}) {
  return axios.get(apiUrl.products.GET.LIST, { params });
}

export function fetchProductGroups(params = {}) {
  return axios.get(apiUrl.productGroups.GET.LIST, { params });
}
